module.exports = __webpack_public_path__ + "img/icon-manejo-libros.56497542.svg";